import React, { useState } from "react";
import { BtnPrimary } from "../../Components/share/buttons/Btn";
import AdminmessageTable from "../../Components/layouts/AdminDashboard/AdminmessageTable";
import MessageModalInfo from "../../Components/layouts/AdminDashboard/MessageModalInfo";
import NewMessageModal from "../../Components/layouts/AdminDashboard/NewMessageModal";
import MessageAnswerModal from "../../Components/layouts/AdminDashboard/MessageAnswerModal";
import { Modal } from "../../Components/share/modal/Modal";

function Adminmessage() {
  const [newMessage, setNewMessage] = useState(false);
  const [Answer, setAnswer] = useState(false);
  const [messageinfo, setMessageinfo] = useState(false);
  const [page, setPage] = useState(0);
  const [coloumn, setColoumn] = useState(3);
  const tableStart = page * coloumn;
  const tableEnd = page * coloumn + coloumn;

  const showAnswer = () => {
    setAnswer(true);
  };
  return (
    <div>
      {" "}
      <div className=" flex SupportTicket__header justify-between items-center">
        <h3 className=" text-[#77498F] text-[1.6rem] font-bold">
          اطلاعات پیام های بوت کمپ
        </h3>
        <BtnPrimary
          text="ارسال پیام جدید"
          className=" px-12 py-8 mt-6 mb-8"
          onClick={() => setNewMessage(true)}
        />
      </div>
      <div>
        <AdminmessageTable
          list={list}
          header={header}
          setAnswer={setAnswer}
          setMessageinfo={setMessageinfo}
          page={page}
          setPage={setPage}
          tableStart={tableStart}
          tableEnd={tableEnd}
        >
          <Modal show={messageinfo}>
            <MessageModalInfo close={setMessageinfo} showAnswer={showAnswer} />
          </Modal>

          <Modal show={newMessage}>
            <NewMessageModal close={setNewMessage} />
          </Modal>

          <Modal show={Answer}>
            <MessageAnswerModal close={setAnswer} />
          </Modal>
        </AdminmessageTable>
      </div>
    </div>
  );
}

export default Adminmessage;

const header = [
  { title: "عنوان پیام" },
  { title: "تاریخ ارسال" },
  { title: "ارسال کننده" },
];
const list = [
  {
    id: 1,
    name: "بررسی حذف مجیری از گروه",
    date: "یکشنبه ۱۴ فروردین ۱۴۰۱ ساعت ۲۰:۳۵ ",
    title: "رمینا",
    btn: "مشاهده ایده",
  },
  {
    id: 2,
    name: "علی رجبی",
    date: "یکشنبه ۱۴ فروردین ۱۴۰۱ ساعت ۲۰:۳۵ ",
    title: "رمینا",
    btn: "مشاهده ایده",
  },
  {
    id: 3,
    name: "علی رجبی",
    date: "یکشنبه ۱۴ فروردین ۱۴۰۱ ساعت ۲۰:۳۵ ",
    title: "شپنا",
    btn: "مشاهده ایده",
  },
  {
    id: 4,
    name: "علی رجبی",
    date: "یکشنبه ۱۴ فروردین ۱۴۰۱ ساعت ۲۰:۳۵ ",
    title: "شپنا",
    btn: "مشاهده ایده",
  },
  {
    id: 5,
    name: "علی رجبی",
    date: "یکشنبه ۱۴ فروردین ۱۴۰۱ ساعت ۲۰:۳۵ ",
    title: "شپنا",
    btn: "مشاهده ایده",
  },
  {
    id: 6,
    name: "علی رجبی",
    date: "یکشنبه ۱۴ فروردین ۱۴۰۱ ساعت ۲۰:۳۵ ",
    title: "شپنا",
    btn: "مشاهده ایده",
  },
];
